import {ComplectationBlock} from "../../data";
import {stateSelectedAccessories} from "../../data/atoms";
import {generateUid} from "../../utils/ApplicationUtils";
import {useRecoilValue} from "recoil";

export const useAccessoriesSelected = (accessories: ComplectationBlock[]) => {
    const selected = useRecoilValue(stateSelectedAccessories);

    return accessories.filter((accessoire) => {
        const uid = generateUid(accessoire.id, accessoire.attributes[0].id);

        return selected.hasOwnProperty(uid);
    });
};
